module.exports = __webpack_public_path__ + "img/5a71ee8.png";